<template>
	<section class="container mt-md-5 mt-3 mb-3 mb-md-5">
		<div v-if="isNews" class="pt-5"></div>
		<nav v-if="isTop" aria-label="breadcrumb" role="navigation" class="mx-auto">
			<ol class="breadcrumb">
				<li class="breadcrumb-item" aria-current="page" itemscope="itemscope" itemtype="http://data-vocabulary.org/Breadcrumb">
				<span itemprop="title" class="text font-weight-bold">News</span>
				</li>
			</ol>
		</nav>
		<div class="row justify-content-center" v-if="!isNews">
			<div v-for="news in nList.slice(0,5)" :key="news.index" class="col-10 col-md-10 m-2 canClick" @click="toNews(news.news_id)">
				<h5 class="newsList pb-2 d-flex"><div class="mr-4 text-nowrap">{{news.news_releasedate}}</div><div>{{news.news_title}}</div></h5>
			</div>
		</div>
		<div class="row justify-content-center" v-if="isNews">
			<div v-for="news in nList" :key="news.index" class="col-10 col-md-10 m-2 canClick" @click="toNews(news.news_id)">
				<h5 class="newsList pb-2 d-flex"><div class="mr-4 text-nowrap">{{news.news_releasedate}}</div><div>{{news.news_title}}</div></h5>
			</div>
		</div>
		<div class="text-center px-5 pt-5 pb-5 row" v-if="isNews">
			<div class="col-2"></div>
			<div class="col-8">
				<input type="button" value="もどる" class="btn btn-color btn-block" @click="backTop()"/>
			</div>
			<div class="col-2"></div>
		</div>
	</section>
</template>

<style>
	.newsList{
		border-bottom: dotted 1px #e9ecef;
	}
	@media(max-width: 768px){
		.newsList span{
			font-size: 0.8rem;
		}
	}
</style>

<script>
export default{
	data(){
		return{
			path:this.$route.path,
			isTop:false,
			isNews:false,
			nList:[],
		}
	},
	created(){
		this.chkPath()
		this.getJson()
	},
	methods:{
		async getJson(){
			await this.$axios
			.get(this.$uri)
			.then((response) => {
				if(response.data.is_maintenance == true){
					window.location.href="/maintenance/maintenance.html"
				}else{
					this.nList = response.data.news_list
				}
			})
			.catch(() => {
				window.location.href="/error/error.html"
			})
		},
		chkPath(){
			if(this.path==='/'){
				this.isTop = true
				this.isNews = false
			}else{
				this.isTop = false
				this.isNews = true
			}
		},
		toNews(id){
			// this.$gtag.query('config', process.env.VUE_APP_UA, {'page_path': '/news/'+id});
			// this.$gtag.query('config', process.env.VUE_APP_GA, {'page_path': '/news/'+id});
			this.$router.push({path:'/news/'+id, params:{'id':id}})
		},
		backTop(){
			this.$router.push({path:'/', params:{}})
		}
	}
}
</script>